import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from '@mui/material/Box';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
export const SortTable = ({
  captionText,
  captionText2,
  headers,
  rows,
  subtitle,
}) => {
    console.log(headers);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("Date");
  const handleSort = (event, property) => {
   console.log(event,property);
    //setOrder(isAsc ? 'desc' : 'asc');
   
  };
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 400 }} aria-label="customized table">
        <caption>
          {captionText}
          <span>{captionText2}</span>
        </caption>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell
              >
                <TableSortLabel
                  active={orderBy===header?true:false}
                  direction={orderBy === header ? order : "asc"}
                  onClick={handleSort(header)}
                >
                  {header}
                 
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SortTable;
